<template>
  <!-- Clinic and Specialities -->
  <section class="section section-specialities body-part-section">
    <div class="container">
      <div class="section-header text-center">
        <h3>Search By Disease, Complaint or Symptoms</h3>
      </div>
      <div class="row justify-content-center">
        <div class="col">
          <!-- Slider -->
          <slick
            class="specialities-slider slider addcursor"
            ref="slick"
            :options="slickOptions"
            v-if="complaints !== undefined"
          >
            <!-- Slider Item -->
            <div
              class="speicality-item text-center"
              :class="{ active: activeitem === index }"
              v-for="(item, index) in complaints"
              :key="index"
              @click="activeImage(index, item.complaints)"
            >
              <div class="speicality-img">
                <img
                  :src="'https://app.bhilwarahealthcare.in' + item.image"
                  class="img-fluid"
                  height="90px"
                  width="90px"
                />
              </div>
              <p>{{ item.complaints }}</p>
            </div>
            <!-- /Slider Item -->
          </slick>
          <!-- /Slider -->
        </div>
      </div>
    </div>
  </section>
  <!-- Clinic and Specialities -->
</template>
<script>
const images = require.context(
  "@/assets/img/specialities",
  false,
  /\.png$|\.jpg$/
);
import CommonApi from "../../services/CommonApi";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      complaints: undefined,
      selected_complaints: "",
      activeitem: undefined,
      slickOptions: {
        slidesToShow: 7,
        infinite: false,
        dots: false,
        arrows: true,
        swipeToSlide: true,
        variableWidth: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.get_complaints();
  },
  watch: {
    selected_complaints: function(val) {
      this.set_selected_complaints(val);
      this.$emit("update-complaints", val);
    },
  },
  methods: {
    ...mapActions(["set_complaints_list", "set_selected_complaints"]),
    next() {
      this.$refs.slick.next();
    },
    prev() {
      this.$refs.slick.prev();
    },
    reInit() {
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
    loadImg(imgPath) {
      return images("./" + imgPath);
    },
    activeImage(id, complaint) {
      if (this.activeitem == id) {
        this.activeitem = undefined;
        this.selected_complaints = "";
      } else {
        this.activeitem = id;
        this.selected_complaints = complaint;
      }
    },
    async get_complaints() {
      await CommonApi.get_data("sahaj.finalapi.get_complaints").then((res) => {
        if (res.status_code == 200) {
          this.complaints = res.data;
          this.set_complaints_list(res.data);
        }
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/kneexpert/Bodypart.vue